import { useState } from "react";
import Button from "../../common/Button";
import Table from "../../common/Table";
import { notify } from "../../common/Toast";
import { salesOrderMaster } from "../../utlis/apiService";
import InputField from "../../common/InputField";
import { IoMdClose } from "react-icons/io";
import { FaPaperPlane, FaWeightHanging, FaBoxOpen } from "react-icons/fa";

const BatchTable = ({ batchItems, batchId, onClose }) => {
  const [isSaving, setIsSaving] = useState(false);
  const totalQty = batchItems.reduce(
    (sum, item) => sum + Number(item.qty || 0),
    0,
  );
  const totalWeight = batchItems
    .reduce((sum, item) => sum + Number(item.qty_Weight || 0), 0)
    .toFixed(2);

  const columns = [
    { key: "order_No", label: "SO NO." },
    { key: "cust_Name", label: "Customer" },
    { key: "dieNumber", label: "Die No." },
    { key: "currentWeight", label: "Current Weight" },
    { key: "profile_Length", label: "Cut Length" },
    { key: "qty", label: "Pcs" },
    { key: "qty_Weight", label: "Weight" },
    { key: "alloy_Name", label: "Alloy" },
    { key: "req_Delivery", label: "Dispatch Date" },
    { key: "status", label: "Days to Dispatch" },
  ];

  const handleSendToProduction = async () => {
    setIsSaving(true);
    try {
      const selectedIds = batchItems.map((item) => item.id);
      if (!selectedIds.length) {
        notify("No items in batch", "error");
        return;
      }
      await salesOrderMaster.SendToProdcution(selectedIds);
      onClose();
      notify("Batch sent to production successfully!", "success");
    } catch (error) {
      console.error("SendToProduction Error:", error);
      notify("Failed to send batch to production", "error");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-[9999]">
      <div className="bg-white border border-gray-300 w-full max-w-6xl max-h-[95vh] flex flex-col overflow-hidden shadow-none">
        <div className="flex justify-between items-center bg-[#0F3D75] text-white p-4 px-6 shrink-0">
          <div>
            <h2 className="text-[14px] font-bold tracking-[2px] uppercase">
              Production Batch Sheet
            </h2>
            <p className="text-white/60 text-[10px] font-bold uppercase tracking-widest mt-1">
              Finalize orders for the production line
            </p>
          </div>
          <button
            onClick={onClose}
            className="hover:bg-white/10 p-1 transition-colors"
          >
            <IoMdClose size={24} />
          </button>
        </div>

        <div className="p-8 overflow-y-auto bg-white">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-gray-50 border border-gray-200 p-6 flex items-center gap-6">
              <div className="bg-[#0F3D75] p-4 text-white">
                <FaBoxOpen size={20} />
              </div>
              <div className="flex flex-col">
                <p className="text-[9px] text-gray-400 font-black uppercase tracking-[2px] mb-1">
                  Total Quantity
                </p>
                <p className="text-[24px] font-black text-gray-800 leading-none">
                  {totalQty}{" "}
                  <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                    pcs
                  </span>
                </p>
              </div>
            </div>
            <div className="bg-gray-50 border border-gray-200 p-6 flex items-center gap-6">
              <div className="bg-[#0F3D75] p-4 text-white">
                <FaWeightHanging size={20} />
              </div>
              <div className="flex flex-col">
                <p className="text-[9px] text-gray-400 font-black uppercase tracking-[2px] mb-1">
                  Total weight
                </p>
                <p className="text-[24px] font-black text-gray-800 leading-none">
                  {totalWeight}{" "}
                  <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                    kg
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="border border-gray-200">
            <Table columns={columns} data={batchItems} showActions={false} />
          </div>

          <div className="mt-10 bg-gray-50 p-8 border border-gray-200 flex flex-col md:flex-row items-end justify-between gap-8">
            <div className="w-full md:max-w-xs">
              <label className="block mb-3 text-[10px] font-black text-gray-500 uppercase tracking-widest">
                Next Production Batch Id
              </label>
              <div className="bg-white border border-gray-200 h-10 flex items-center px-4 text-[12px] font-bold text-gray-700">
                {batchId}
              </div>
            </div>

            <div className="flex gap-3">
              <button
                type="button"
                onClick={onClose}
                className="px-8 py-2.5 border border-gray-300 text-gray-600 font-bold text-[11px] uppercase tracking-widest hover:bg-white transition-colors"
              >
                Discard Batch
              </button>
              <button
                type="button"
                className="px-12 py-2.5 bg-[#0F3D75] text-white font-bold text-[11px] uppercase tracking-widest border border-[#0F3D75] hover:bg-[#0a2e58] transition-colors flex items-center gap-3 disabled:opacity-50"
                onClick={handleSendToProduction}
                disabled={isSaving}
              >
                {isSaving ? "Send..." : (
                  <>
                    <FaPaperPlane size={14} />
                    Send to Production
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default BatchTable;
